import {
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION,
  DOWNLOADS,
  ERROR,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_FACEBOOK,
  FIELD_TRAFFIC_URL_NOT_BE_LINK_WHATSAPP,
  INTERACTIONS,
  LEADS,
  SALES,
} from "../i18n/keysTranslations";
import { errorCodeToText, getProviderInterpolationForError } from "./errors";
import { REGEX_YOUTUBE_URL } from "./regex";
import AES from "crypto-js/aes";
import logoYT from "../assets/img/logo-yt.png";
import logoIG from "../assets/img/logo-ig.webp";
import logoFB from "../assets/img/logo-fb.webp";
import logoIGWhite from "../assets/img/logo-ig-white.png";
import logoTikTok from "../assets/img/logo-tiktok.webp";
import logoTikTokBusiness from "../assets/img/logo-tiktok-business.webp";
import logoCanva from "../assets/img/logo-canva.webp";
import logoMeta from "../assets/img/logo-meta.webp";
import logoMetaWhite from "../assets/img/logo-meta-white.webp";
import logoGoogle from "../assets/img/logo-google-ads.webp";
import logoLinkedIn from "../assets/img/logo-linkedin.webp";
import {
  INSTAGRAM,
  INSTAGRAM_WHITE,
  TIKTOK,
  YOUTUBE,
  FACEBOOK,
  META,
  META_WHITE,
  TIKTOK_BUSINESS,
  ALERT_ICON_TYPE_ERROR,
  CANVA,
  GOOGLE,
  IMAGE_FORMATS,
  VIDEO_FORMATS,
  MAX_SIZE_FILES,
  MAX_SIZE_IMAGE,
  LINKEDIN,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  CAMPAIGNS_WITH_DATES_IN_CAMPAIGN_LEVEL,
} from "./constants";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DownloadIcon from "@mui/icons-material/Download";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { SimpleAlert } from "../components/Alerts/Alerts";
import i18next from "i18next";
import imageCompression from "browser-image-compression";
import { getUniqueID } from "./numbers";
import _ from "lodash";
import CryptoJS from "crypto-js";

export const hashStringToID = (string = "") => {
  return CryptoJS.SHA256(string).toString(CryptoJS.enc.Hex);
};

export const removeContactInfoFromString = (message) => {
  // This regex pattern should catch more phone numbers (including international ones) but still may not cover all cases.
  const phoneNumberRegex = /(\+\d{1,3})?([.\s]?\d){5,15}/g;

  const spelledNumberRegex =
    /\b(zero|one|two|three|four|five|six|seven|eight|nine|cero|uno|dos|tres|cuatro|cinco|seis|siete|ocho|nueve)\b/gi;

  // This regex pattern is for detecting email addresses.
  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;

  // // Simple regex pattern for URLs (http, https, www)
  //eslint-disable-next-line
  // const urlRegex = /(\b(https?:\/\/|www\.)[-A-Z0-9+&@#\/%?=_|!:,.;]*[-A-Z0-9+&@#\/%=_|])/gi;

  // // Replace detected phone numbers, email addresses and URLs with '**'
  let sanitizedMessage = message.replace(emailRegex, "**");
  sanitizedMessage = sanitizedMessage.replace(phoneNumberRegex, " ***");
  sanitizedMessage = sanitizedMessage.replace(spelledNumberRegex, " ***");
  // sanitizedMessage = sanitizedMessage.replace(urlRegex, "**");

  return sanitizedMessage;
};

export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getUUIDFromURL = (url) => {
  url = decodeURIComponent(url);

  let fragments = url.split("/");
  let uuid = fragments[fragments.length - 1];
  if (uuid.indexOf("?") !== -1) {
    uuid = uuid.split("?")[0];
  }

  return uuid;
};

export const openLink = (url) => window.open(url, "_blank");

export const getObjectError = (error) => {
  if (error?.response?.data) {
    const codeError = error?.response?.data?.code;
    console.log(codeError);
    const messageError = error?.response?.data?.message;
    const dataError = error?.response?.data?.data;
    const failedIntegrations = error?.response?.data?.failedIntegrations;
    const providerInterpolation = getProviderInterpolationForError(
      codeError,
      error?.response?.data?.provider
    );
    const errorTranslated = errorCodeToText(codeError, providerInterpolation);
    return {
      ok: false,
      code: codeError,
      message: errorTranslated === codeError ? messageError : errorTranslated,
      provider: error?.response?.data?.provider,
      paymentMode: error?.response?.data?.paymentMode,
      data: { ...dataError, failedIntegrations },
      failedIntegrations,
    };
  }

  const codeError = error?.code;
  const messageError = error?.message;
  const providerInterpolation = getProviderInterpolationForError(
    codeError,
    error?.provider
  );
  const errorTranslated = errorCodeToText(codeError, providerInterpolation);

  return {
    ok: false,
    code: codeError,
    message:
      codeError != null && errorTranslated !== codeError
        ? errorTranslated
        : (messageError ?? errorTranslated),
    provider: error?.provider,
    paymentMode: error?.paymentMode,
    data: { failedIntegrations: error?.failedIntegrations },
    failedIntegrations: error?.failedIntegrations,
  };
};

export const encryptPassword = (password) => {
  try {
    const bytes = AES.encrypt(
      password,
      import.meta.env.VITE_KEY_ENCRYPT
    ).toString();
    return bytes;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const logoPlatform = (platform) => {
  switch (platform) {
    case TIKTOK:
      return logoTikTok;
    case TIKTOK_BUSINESS:
      return logoTikTokBusiness;
    case INSTAGRAM:
      return logoIG;
    case INSTAGRAM_WHITE:
      return logoIGWhite;
    case YOUTUBE:
      return logoYT;
    case FACEBOOK:
      return logoFB;
    case META:
      return logoMeta;
    case META_WHITE:
      return logoMetaWhite;
    case CANVA:
      return logoCanva;
    case GOOGLE:
      return logoGoogle;
    case LINKEDIN:
      return logoLinkedIn;
    default:
      break;
  }
};
const MIME_TYPE_TO_EXTENSION = {
  "image/jpeg": "jpg",
  "image/jpg": "jpg",
  "image/png": "png",
  "image/gif": "gif",
  "image/webp": "webp",
  "video/mp4": "mp4",
  "video/quicktime": "quicktime",
  "video/webm": "webm",
  "video/x-msvideo": "avi",
  "video/avi": "avi",
  "video/mov": "mov",
};

export const getExtensionFile = (url = "") => {
  if (typeof url !== "string") return "";
  if (url.startsWith("data:image/")) {
    const mimeMatch = url.match(/^data:image\/([a-zA-Z0-9+.-]+)/);
    const subtype = mimeMatch?.[1]?.split(";")?.[0]?.toLowerCase();
    if (subtype === "jpeg") return "jpg";
    if (subtype) return subtype;
    return "png";
  }
  if (url.startsWith("data:")) {
    const mimeMatch = url.match(/^data:([^;,]+)/);
    if (!mimeMatch) return "";
    const mime = mimeMatch[1].toLowerCase();
    if (MIME_TYPE_TO_EXTENSION[mime]) {
      return MIME_TYPE_TO_EXTENSION[mime];
    }
    const subtype = mime.split("/")[1];
    return subtype ? subtype.toLowerCase() : "";
  }
  if (url?.includes("blob:")) {
    const urlSplit = url.split("ext=");
    const extension = urlSplit[urlSplit.length - 1];

    return extension.toLowerCase();
  }
  const finalUrl = url.split("?")[0];
  const lengthUrlSplit = finalUrl.split(".");
  const extension = lengthUrlSplit[lengthUrlSplit.length - 1].split("?")[0];
  return extension.toLowerCase();
};

// Short alphanumeric suffixes that look like real file extensions (jpg, mp4, svg…).
// CDN paths without an extension often yield fragments like "com/arquivos/ids/208184-800-auto".
const KNOWN_FILE_EXTENSION_PATTERN = /^[a-z0-9]{1,5}$/;

// Prefer image for IMAGE_FORMATS and extensionless CDN URLs; keep known videos as video.
export const isLikelyImageUrl = (url = "") => {
  if (typeof url !== "string" || !url) return false;
  if (url.startsWith("data:image/")) return true;
  if (url.startsWith("data:video/")) return false;
  if (
    url.includes("googlesyndication.com") ||
    url.includes("googleusercontent.com")
  ) {
    return true;
  }

  const extension = getExtensionFile(url);
  if (IMAGE_FORMATS.includes(extension)) return true;
  if (VIDEO_FORMATS.includes(extension)) return false;
  if (!extension) return true;
  if (!KNOWN_FILE_EXTENSION_PATTERN.test(extension)) return true;

  return false;
};

// CDN/product URLs without jpg/png/webp cannot be read by image models; persist to our S3 first.
export const needsStoragePersistForImageUrl = (url = "") => {
  if (typeof url !== "string" || !url) return false;
  if (url.startsWith("data:")) return false;
  if (!isLikelyImageUrl(url)) return false;
  return !IMAGE_FORMATS.includes(getExtensionFile(url));
};

export const formatUrlMedia = (url = "") => {
  if (url?.includes("blob:")) {
    return url?.split("?")[0];
  }
  return url;
};

export async function downloadContent(urlFrom) {
  try {
    const response = await fetch(urlFrom, {
      cache: "no-store",
    });

    if (response.ok) {
      const blob = await response.blob();
      let fileName = getUUIDFromURL(urlFrom);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");

      const extension = getExtensionFile(urlFrom);
      if (extension === "quicktime") {
        fileName = fileName.replace("quicktime", "mov");
      }

      a.style.display = "none";
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);
    }
    return response.ok;
  } catch (error) {
    console.error(error);
    SimpleAlert({
      title: i18next.t(ERROR),
      text: error.message,
      icon: ALERT_ICON_TYPE_ERROR,
    });
  }
}

export const getFileFromUrl = async (url) => {
  try {
    const response = await fetch(url, {
      cache: "no-store",
    });
    if (response.ok) {
      const data = await response.blob();
      return data;
    }
    return false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const getHeightAndWidthFromDataUrl = (file) =>
  new Promise((resolve) => {
    const dataURL = window.URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      resolve({
        height: img.height,
        width: img.width,
      });
    };
    img.src = dataURL;
  });

export const getAnalyticsByUser = (user = {}) => {
  return {
    followers: user.followers || 0,
    engagement: user.engagement || 0,
    detailedAnalytics: user.detailedAnalytics || "",
  };
};

export const getKeyMetricAdsCampaign = (data = {}) => {
  const objective = data.objective;
  const statistics = data.statistics || {};

  if (objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION) {
    return {
      value: statistics.interactions,
      label: INTERACTIONS,
      icon: ThumbUpIcon,
    };
  }
  if (objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION) {
    return {
      value: statistics.leads,
      label: LEADS,
      icon: AssignmentTurnedInIcon,
    };
  }
  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION
  ) {
    return {
      value: statistics.downloads,
      label: DOWNLOADS,
      icon: DownloadIcon,
    };
  }
  if (objective === ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION) {
    return {
      value: statistics.sales,
      label: SALES,
      icon: MonetizationOnIcon,
    };
  }
};

export const getInfluencerSocialLink = (influencer = {}) => {
  const { mainPlatform, mainAccountName } = influencer;

  if (mainPlatform === "instagram") {
    return `https://www.instagram.com/${mainAccountName}`;
  }
  if (mainPlatform === "tiktok") {
    return `https://www.tiktok.com/@${mainAccountName}`;
  }
  if (mainPlatform === "youtube") {
    return `https://www.youtube.com/c/${mainAccountName}`;
  }
};

/** Normalizes item to {id, value} - backend may return string or {id, value} */
const toIdValue = (item) => {
  const normalized =
    typeof item === "object" && item?.value !== undefined ? item.value : item;
  return { id: getUniqueID(), value: normalized };
};

export const getFormattedCampaign = ({ data = {}, format = "load" }) => {
  let campaignFormatted = _.cloneDeep(data);

  if (format === "load") {
    campaignFormatted = {
      ...campaignFormatted,
      adsGroups: [],
      assetsGroups: [],
    };

    if (campaignFormatted?.platformsData?.[GOOGLE]?.callOuts?.length > 0) {
      campaignFormatted.platformsData[GOOGLE].callOuts =
        campaignFormatted.platformsData[GOOGLE].callOuts.map(toIdValue);
    }

    CAMPAIGNS_WITH_DATES_IN_CAMPAIGN_LEVEL.forEach((platform) => {
      if (campaignFormatted?.platformsData?.[platform]?.startDate) {
        campaignFormatted.platformsData[platform].startDate = new Date(
          campaignFormatted.platformsData[platform].startDate
        ).getTime();
      }
      if (campaignFormatted?.platformsData?.[platform]?.endDate) {
        campaignFormatted.platformsData[platform].endDate = new Date(
          campaignFormatted.platformsData[platform].endDate
        ).getTime();
      }
    });

    const assetsGroups = Object.keys(data.assetsGroups || {});
    const assetsGroupsKeysSortedByLetters = [...assetsGroups].sort();

    assetsGroupsKeysSortedByLetters.forEach((key) => {
      const assetGroup = data.assetsGroups[key];
      const assetGroupFormatted = {
        ...assetGroup,
        titles: assetGroup.titles ? assetGroup.titles.map(toIdValue) : [],
        longHeadlines: assetGroup.longHeadlines
          ? assetGroup.longHeadlines.map(toIdValue)
          : [],
        descriptions: assetGroup.descriptions
          ? assetGroup.descriptions.map(toIdValue)
          : [],
        // LinkedIn specific fields
        headlines: assetGroup.headlines
          ? assetGroup.headlines.map(toIdValue)
          : [],
        destinationUrls: assetGroup.destinationUrls
          ? assetGroup.destinationUrls.map(toIdValue)
          : [],
      };

      campaignFormatted.assetsGroups.push(assetGroupFormatted);
    });

    const adsGroups = Object.keys(data.adsGroups || {});
    const adsGroupsKeysSortedByLetters = [...adsGroups].sort();

    adsGroupsKeysSortedByLetters.forEach((key) => {
      const adGroup = data.adsGroups[key];
      const adGroupFormatted = {
        ...adGroup,
        ads: [],
      };

      if (adGroupFormatted.startDate) {
        adGroupFormatted.startDate = new Date(
          adGroupFormatted.startDate
        ).getTime();
      }
      if (adGroupFormatted.endDate) {
        adGroupFormatted.endDate = new Date(adGroupFormatted.endDate).getTime();
      }

      if (!_.isEmpty(adGroup.titles)) {
        adGroupFormatted.titles = adGroup.titles.map(toIdValue);
      }
      if (!_.isEmpty(adGroup.descriptions)) {
        adGroupFormatted.descriptions = adGroup.descriptions.map(toIdValue);
      }

      const ads = Object.keys(adGroup.ads || {});
      const adsKeysSortedByLetters = [...ads].sort();
      adsKeysSortedByLetters.forEach((key) => {
        const ad = adGroup.ads[key];
        const titles = ad.titles
          ? ad.titles.map(toIdValue)
          : [
              {
                value: "",
                id: getUniqueID(),
              },
            ];
        const descriptions = ad.descriptions
          ? ad.descriptions.map(toIdValue)
          : [
              {
                value: "",
                id: getUniqueID(),
              },
            ];
        const headlines = ad.headlines
          ? ad.headlines.map(toIdValue)
          : [
              {
                value: "",
                id: getUniqueID(),
              },
            ];
        const destinationUrls = ad.destinationUrls
          ? ad.destinationUrls.map(toIdValue)
          : [
              {
                value: "",
                id: getUniqueID(),
              },
            ];

        const adFormatted = {
          ...ad,
          titles,
          descriptions,
          headlines,
          destinationUrls,
        };

        adGroupFormatted.ads.push(adFormatted);
      });

      campaignFormatted.adsGroups.push(adGroupFormatted);
    });
  }

  if (format === "save") {
    campaignFormatted = {
      ...campaignFormatted,
      adsGroups: {},
      assetsGroups: {},
    };

    if (campaignFormatted?.platformsData?.[GOOGLE]?.callOuts?.length > 0) {
      campaignFormatted.platformsData[GOOGLE].callOuts =
        campaignFormatted.platformsData[GOOGLE].callOuts.map(
          (callout) => callout.value
        );
    }

    CAMPAIGNS_WITH_DATES_IN_CAMPAIGN_LEVEL.forEach((platform) => {
      if (campaignFormatted?.platformsData?.[platform]?.startDate) {
        const startDate = campaignFormatted.platformsData[platform].startDate;
        campaignFormatted.platformsData[platform].startDate = _.isDate(
          startDate
        )
          ? startDate.getTime()
          : new Date(startDate).getTime();
      }

      if (campaignFormatted?.platformsData?.[platform]?.endDate) {
        const endDate = campaignFormatted.platformsData[platform].endDate;
        campaignFormatted.platformsData[platform].endDate = _.isDate(endDate)
          ? endDate.getTime()
          : new Date(endDate).getTime();
      }
    });

    (data.assetsGroups || []).forEach((assetGroupKey, indexAssetsGroup) => {
      const assetGroup = data.assetsGroups[indexAssetsGroup];
      const assetGroupFormatted = {
        ...assetGroup,
        titles: assetGroup.titles
          ? assetGroup.titles.map((title) => title?.value || "")
          : [],
        longHeadlines: assetGroup.longHeadlines
          ? assetGroup.longHeadlines.map((headline) => headline?.value || "")
          : [],
        descriptions: assetGroup.descriptions
          ? assetGroup.descriptions.map(
              (description) => description?.value || ""
            )
          : [],
        // LinkedIn specific fields
        headlines: assetGroup.headlines
          ? assetGroup.headlines.map((headline) => headline?.value || "")
          : [],
        destinationUrls: assetGroup.destinationUrls
          ? assetGroup.destinationUrls.map((url) => url?.value || "")
          : [],
      };

      campaignFormatted.assetsGroups[assetGroup.id] = assetGroupFormatted;
    });

    (data.adsGroups || []).forEach((adGroupKey, indexAdGroup) => {
      const adGroup = data.adsGroups[indexAdGroup];
      const adGroupFormatted = { ...adGroup, ads: {} };

      if (adGroupFormatted.startDate) {
        adGroupFormatted.startDate = _.isDate(adGroupFormatted.startDate)
          ? adGroupFormatted.startDate.getTime()
          : new Date(adGroupFormatted.startDate).getTime();
      }
      if (adGroupFormatted.endDate) {
        adGroupFormatted.endDate = _.isDate(adGroupFormatted.endDate)
          ? adGroupFormatted.endDate.getTime()
          : new Date(adGroupFormatted.endDate).getTime();
      }

      if (!_.isEmpty(adGroup.titles)) {
        adGroupFormatted.titles = adGroup.titles.map((title) => title.value);
      }
      if (!_.isEmpty(adGroup.descriptions)) {
        adGroupFormatted.descriptions = adGroup.descriptions.map(
          (description) => description.value
        );
      }

      (adGroup.ads || []).forEach((adKey, indexAd) => {
        const ad = adGroup.ads[indexAd];
        const titles = ad.titles ? ad.titles.map((title) => title.value) : null;
        const descriptions = ad.descriptions
          ? ad.descriptions.map((description) => description?.value || "")
          : null;
        const headlines = ad.headlines
          ? ad.headlines.map((headline) => headline?.value || "")
          : null;
        const destinationUrls = ad.destinationUrls
          ? ad.destinationUrls.map(
              (destinationUrl) => destinationUrl?.value || ""
            )
          : null;

        const adFormatted = {
          ...ad,
          titles,
          descriptions,
          headlines,
          destinationUrls,
        };

        adGroupFormatted.ads[ad.id] = adFormatted;
      });

      campaignFormatted.adsGroups[adGroup.id] = adGroupFormatted;
    });
  }

  return campaignFormatted;
};

export const normalizeUrlToCompare = ({ url = "", returnHostname = false }) => {
  try {
    if (typeof url !== "string") return url;

    let formattedUrl = url.toLowerCase().trim();

    if (!formattedUrl.startsWith("http")) {
      formattedUrl = `https://${formattedUrl}`;
    }

    if (!formattedUrl.includes("www.")) {
      formattedUrl = formattedUrl.replace("https://", "https://www.");
    }

    const urlObj = new URL(formattedUrl);

    if (returnHostname) {
      return urlObj.hostname;
    }

    return formattedUrl;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const getLanguageFormatted = (language) => {
  const languageFormatted = language.split("-")[0];

  switch (languageFormatted) {
    case "en":
    case "es":
      return languageFormatted;

    default:
      return "en";
  }
};

export const compressImage = async (file, optionsProp) => {
  try {
    const options = optionsProp || {
      maxSizeMB: 3,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
      initialQuality: 0.85,
    };
    const compressedFile = await imageCompression(file, options);
    return compressedFile;
  } catch (error) {
    console.log(error);
    SimpleAlert({
      title: "Error",
      text: "Error comprimiendo el archivo",
      icon: ALERT_ICON_TYPE_ERROR,
    });
    return false;
  }
};
export const isImage = (file) => {
  const ext = file.type.split("/")[1];
  if (IMAGE_FORMATS.includes(ext)) return true;
  return false;
};

export const validateFile = (file) => {
  const ext = file.type.split("/")[1];
  if (
    ext !== "pdf" &&
    !IMAGE_FORMATS.includes(ext) &&
    !VIDEO_FORMATS.includes(ext)
  ) {
    SimpleAlert({
      title: "Error",
      text: "El formato del archivo no es valido",
      icon: ALERT_ICON_TYPE_ERROR,
    });
    return false;
  }
  if (IMAGE_FORMATS.includes(ext) && file.size > MAX_SIZE_IMAGE) {
    SimpleAlert({
      title: "Error",
      text: "La imagen es muy grande, por favor selecciona una con un tamaño menor a 10MB",
      icon: ALERT_ICON_TYPE_ERROR,
    });
    return false;
  }
  if (
    (VIDEO_FORMATS.includes(ext) || ext === "pdf") &&
    file.size > MAX_SIZE_FILES
  ) {
    SimpleAlert({
      title: "Error",
      text: "El archivo es muy grande, por favor selecciona uno con un tamaño menor a 30MB",
      icon: ALERT_ICON_TYPE_ERROR,
    });
    return false;
  }
  return true;
};

export const verifyDestinationURLIsABlockedDomain = ({
  destinationURL = "",
  destinationType = ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  platform,
}) => {
  if (platform !== META) return { ok: true };

  if (destinationType !== ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION)
    return { ok: true };

  if (destinationURL?.includes("facebook.com")) {
    return {
      ok: false,
      message: FIELD_TRAFFIC_URL_NOT_BE_LINK_FACEBOOK,
    };
  }

  // if (destinationURL.includes("instagram.com")) {
  //   return {
  //     ok: false,
  //     message: FIELD_TRAFFIC_URL_NOT_BE_LINK_INSTAGRAM,
  //   };
  // }

  if (destinationURL?.includes("whatsapp.com")) {
    return {
      ok: false,
      message: FIELD_TRAFFIC_URL_NOT_BE_LINK_WHATSAPP,
    };
  }

  return {
    ok: true,
  };
};

export const removeAllWhiteSpaces = (str = "") => {
  return str.replace(/\s/g, "");
};

export const getDimensionsFromFileHtml = async ({ file, urlBlob }) => {
  if (!urlBlob) {
    urlBlob = URL.createObjectURL(file);
  }

  const getImageDimensions = (imageUrl) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = imageUrl;
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
    });
  };

  const getVideoDimensions = (videoUrl = "") => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.src = videoUrl;
      video.onloadedmetadata = () => {
        resolve({ width: video.videoWidth, height: video.videoHeight });
      };
    });
  };

  if (file.type.startsWith("image/")) {
    return await getImageDimensions(urlBlob);
  } else if (file.type.startsWith("video/")) {
    return await getVideoDimensions(urlBlob);
  }

  return { width: 0, height: 0 };
};

export const getKeywordMatchType = (text = "") => {
  if (typeof text !== "string") return { text, matchType: "broad" };
  text = text.trim();
  if (text.startsWith("[") && text.endsWith("]")) {
    return {
      text: text.slice(1, -1),
      matchType: "exact",
    };
  }
  if (text.startsWith('"') && text.endsWith('"')) {
    return {
      text: text.slice(1, -1),
      matchType: "phrase",
    };
  }
  return {
    text,
    matchType: "broad",
  };
};

// Convert file to base64 string
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const blobUrlToBase64 = async (blobUrl) => {
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  try {
    // Remove query parameters from blob URL if present (e.g., ?ext=png)
    const cleanBlobUrl = blobUrl.split("?")[0];

    const response = await fetch(cleanBlobUrl);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();

    if (!blob || blob.size === 0) {
      throw new Error("Empty blob received");
    }

    return { ok: true, data: await fileToBase64(blob) };
  } catch (error) {
    console.error("Error converting blob URL to base64:", error);
    return {
      ok: false,
      message: error.message || "Error converting blob URL to base64",
    };
  }
};

export const getMimeTypeFromExtension = (extension) => {
  const ext = extension.toLowerCase();

  if (IMAGE_FORMATS.includes(ext)) {
    if (ext === "jpg" || ext === "jpeg") return "image/jpeg";
    if (ext === "png") return "image/png";
    if (ext === "webp") return "image/webp";
    return "image/jpeg"; // Default for images
  }

  if (VIDEO_FORMATS.includes(ext)) {
    if (ext === "mp4") return "video/mp4";
    if (ext === "mov") return "video/quicktime";
    if (ext === "webm") return "video/webm";
    return "video/mp4"; // Default for videos
  }

  return "application/octet-stream"; // Default fallback
};

export const blobUrlToFile = async (blobUrl) => {
  try {
    // Clean blob URL (remove query parameters if present)
    const cleanBlobUrl = formatUrlMedia(blobUrl);

    // Fetch the blob from the URL
    const response = await fetch(cleanBlobUrl, {
      cache: "no-store",
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch blob: ${response.status}`);
    }

    const blob = await response.blob();

    // Get extension from original URL
    const extension = getExtensionFile(blobUrl);
    const mimeType = getMimeTypeFromExtension(extension);

    // Generate filename with extension
    const fileName = `media_${Date.now()}.${extension}`;

    // Create File from Blob
    const file = new File([blob], fileName, {
      type: mimeType,
      lastModified: Date.now(),
    });

    return file;
  } catch (error) {
    console.error("Error converting blob URL to File:", error);
    throw error;
  }
};

export const getIsVideoYoutube = (url = "") => {
  return url?.includes("youtube.com") || url?.includes("youtu.be");
};

export const getYoutubeVideoIdFromUrl = ({ url = "" } = {}) => {
  const match = url.match(REGEX_YOUTUBE_URL);
  if (match?.[4]) {
    return match[4].slice(0, 11);
  }

  return extractYoutubeVideoIdLoose({ url });
};

export const extractYoutubeVideoIdLoose = ({ url = "" } = {}) => {
  if (!url || typeof url !== "string") {
    return null;
  }

  const trimmed = url.trim();

  const youtuBeMatch = trimmed.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (youtuBeMatch?.[1]) {
    return youtuBeMatch[1];
  }

  const embedMatch = trimmed.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
  if (embedMatch?.[1]) {
    return embedMatch[1];
  }

  const watchMatch = trimmed.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
  if (watchMatch?.[1]) {
    return watchMatch[1];
  }

  const shortsMatch = trimmed.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/);
  if (shortsMatch?.[1]) {
    return shortsMatch[1];
  }

  return null;
};

export const normalizeYoutubeWatchUrl = ({ url = "" } = {}) => {
  const videoId = extractYoutubeVideoIdLoose({ url });
  if (!videoId) {
    const trimmed = url?.trim();
    return trimmed || null;
  }

  return `https://www.youtube.com/watch?v=${videoId}`;
};
